<template>
  <div
    class="parent clearfix container max-auto px-10 pb-[80px]"
    style="height: 90vh"
  >
    <div class="login pt-5">
      <div class="container">
        <span class="flex justify-between  items-center">
          <img
            class="md:height-[100px] height-60px md:w-[100px] w-[60px]"
            src="compressed-logo.png"
            alt="Logo"
          />
          <div class="pl-2 text-black">
            <div class="text-[15px] text-center" style="margin-top: 30px;"
              >SPECIALIZED HEALTHCARE & MEDICAL EDUCATION DEPARTMENT, GOVERNMENT OF PUNJAB
          </div>
            <br />
            <!-- </div> -->
            <!-- <span class="text-[15px] text-black"> </span> -->
          </div>
        </span>
        <h1 class="flex justify-center mt-10 mb-5">Login</h1>
        <div class="login-form">
          <form @submit.prevent="handleLogins">
            <input type="text" v-model="username" placeholder="username" />
            <input type="password" v-model="password" placeholder="password" />
            <div class="flex justify-center" style="margin-top: -30px;">
              <button type="submit" class="bg-save" style="text-transform: none;">Login</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useAuthService } from "@/store/Auth"; //  auth.js file
import { ref } from "vue"; // Import ref from Vue
import { useRouter } from "vue-router";
import Swal from "sweetalert2";
const authStore = useAuthService();
const router = useRouter(); // Initialize the router object
const username = ref("");
const password = ref("");

// eslint-disable-next-line no-unused-vars
const handleLogins = async () => {
  try {
    const token = await authStore.login(username.value, password.value);
    if (token) {
      Swal.fire({
        toast: true,
        title: "Successfully Login ",
        icon: "success",
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
      });
      router.push({ name: "Home" });
    }
  } catch (error) {
    Swal.fire({
      toast: true,
      title: "Username and password are not correct",
      icon: "error",
      position: "top-end",
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
    });

    console.error("Login Error:", error);
  }
};
</script>
<style scoped>
article,
aside,
details,
figure,
footer,
header,
main,
menu,
nav,
section,
summary {
  display: block;
}

h1,
h2,
h3,
h4,
h5,
h6,
p,
a {
  -ms-word-wrap: break-word;
  word-wrap: break-word;
  text-decoration: none;
}

img {
  border: none;
}

*:focus {
  outline: none;
}

.clearfix::after {
  content: "";
  display: table;
  clear: both;
}

.bg-illustration {
  position: relative;
  height: 100vh;
  width: 1194px;
  background: url("https://brandeps.com/logo-download/F/Flag-map-of-Pakistan-logo-vector-01.svg")
    no-repeat center center scroll;
  background-size: cover;
  float: left;
  -webkit-animation: bgslide 2.3s forwards;
  animation: bgslide 2.3s forwards;
}

.bg-illustration img {
  width: 248px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  height: auto;
  margin: 19px 0 0 25px;
}

@-webkit-keyframes bgslide {
  from {
    left: -100%;
    width: 0;
    opacity: 0;
  }

  to {
    left: 0;
    width: 1194px;
    opacity: 1;
  }
}

@keyframes bgslide {
  from {
    left: -100%;
    width: 0;
    opacity: 0;
  }

  to {
    left: 0;
    width: 1194px;
    opacity: 1;
  }
}

.login {
  max-height: 100vh;
  float: left;
  margin: 0 auto;
  width: 100%;
}

.login .container {
  width: 505px;
  margin: 0 auto;
  position: relative;
}

.login .container h1 {
  /* margin-top: 100px; */
  font-size: 35px;
  font-weight: bolder;
}

/* .login .container .login-form {
  margin-top: 112px;
} */

.login .container .login-form form {
  display: -ms-grid;
  display: grid;
}

.login .container .login-form form input {
  font-size: 16px;
  font-weight: normal;
  background: rgba(57, 57, 57, 0.07);
  margin: 12.5px 0;
  height: 68px;
  border: none;
  padding: 0 30px;
  border-radius: 10px;
}

.login .container .login-form form button[type="submit"] {
  background: #02c782;
  border: none;
  margin-top: 50px;
  margin-bottom: 20px;
  width: 241px;
  height: 58px;
  text-transform: uppercase;
  color: white;
  border-radius: 10px;
  position: relative;
  z-index: 2;
  font-weight: bold;
  font-size: 20px;
}

.login .container .login-form form button[type="submit"]:hover::after {
  opacity: 1;
}

.login .container .login-form form button[type="submit"]::after {
  content: "";
  position: absolute;
  z-index: -1;
  border-radius: 10px;
  opacity: 0;
  top: 0;
  left: 0;
  -webkit-transition: 0.3s ease-in-out;
  -o-transition: 0.3s ease-in-out;
  transition: 0.3s ease-in-out;
  right: 0;
  bottom: 0;

  /* background: -webkit-linear-gradient(bottom, #09203f 0%, #537895 100%);
  background: -o-linear-gradient(bottom, #09203f 0%, #537895 100%);
  background: linear-gradient(to top, #09203f 0%, #537895 100%); */
}

.login .container .remember-form {
  position: relative;
  margin-top: -30px;
}

.login .container .remember-form input[type="checkbox"] {
  margin-top: 9px;
}

.login .container .remember-form span {
  font-size: 18px;
  font-weight: normal;
  position: absolute;
  top: 32px;
  color: #3b3b3b;
  margin-left: 15px;
}

.login .container .forget-pass {
  position: absolute;
  right: 0;
  margin-top: 189px;
}

.login .container .forget-pass a {
  font-size: 16px;
  position: relative;
  font-weight: normal;
  color: #918f8f;
}

.login .container .forget-pass a::after {
  content: "";
  position: absolute;
  height: 2px;
  width: 100%;
  border-radius: 100px;
  background: -webkit-linear-gradient(110deg, #f794a4 0%, #fdd6bd 100%);
  background: -o-linear-gradient(110deg, #f794a4 0%, #fdd6bd 100%);
  background: linear-gradient(-20deg, #f794a4 0%, #fdd6bd 100%);
  bottom: -4px;
  left: 0;
  -webkit-transition: 0.3s;
  -o-transition: 0.3s;
  transition: 0.3s;
  opacity: 0;
  right: 0;
}

.login .container .forget-pass a:hover::after {
  opacity: 1;
}

@media only screen and (min-width: 1024px) and (max-width: 1680px) {
  .bg-illustration {
    width: 50%;
    -webkit-animation: none;
    animation: none;
  }
}

/* Display 12", iPad PRO Portrait, iPad landscape */
@media only screen and (max-width: 1024px) {
  body {
    overflow-x: hidden;
  }

  @-webkit-keyframes slideIn {
    from {
      left: -100%;
      opacity: 0;
    }

    to {
      left: 0;
      opacity: 1;
    }
  }

  @keyframes slideIn {
    from {
      left: -100%;
      opacity: 0;
    }

    to {
      left: 0;
      opacity: 1;
    }
  }

  .bg-illustration {
    float: none;
    background: url("https://brandeps.com/logo-download/F/Flag-map-of-Pakistan-logo-vector-01.svg")
      center center;
    background-size: cover;
    -webkit-animation: slideIn 0.8s ease-in-out forwards;
    animation: slideIn 0.8s ease-in-out forwards;
    width: 100%;
    height: 190px;
    text-align: center;
  }

  .bg-illustration img {
    width: 100px;
    height: auto;
    margin: 20px auto !important;
    text-align: center;
  }

  .bg-illustration .burger-btn {
    left: 33px;
    top: 29px;
    display: block;
    position: absolute;
  }

  .bg-illustration .burger-btn span {
    display: block;
    height: 4px;
    margin: 6px;
    background-color: #fff;
  }

  .bg-illustration .burger-btn span:nth-child(1) {
    width: 37px;
  }

  .bg-illustration .burger-btn span:nth-child(2) {
    width: 28px;
  }

  .bg-illustration .burger-btn span:nth-child(3) {
    width: 20px;
  }

  .login {
    float: none;
    margin: 0 auto;
    width: 100%;
  }

  .login .container {
    -webkit-animation: slideIn 0.8s ease-in-out forwards;
    animation: slideIn 0.8s ease-in-out forwards;
    width: 85%;
    float: none;
  }

  .login .container h1 {
    font-size: 25px;
    margin-top: 40px;
  }

  .login .container .login-form {
    margin-top: 20px;
  }

  .login .container .login-form form input {
    height: 45px;
  }

  .login .container .login-form form button[type="submit"] {
    height: 45px;
    margin-top: 100px;
  }

  .login .container .login-form .remember-form {
    position: relative;
    margin-top: -14px;
  }

  .login .container .login-form .remember-form span {
    font-size: 16px;
    margin-top: 22px;
    top: inherit;
  }

  .forget-pass {
    position: absolute;
    right: inherit;
    left: 0;
    bottom: -40px;
    margin: 0 !important;
  }

  .forget-pass a {
    font-size: 16px;
    position: relative;
    font-weight: normal;
    color: #918f8f;
  }

  .forget-pass a::after {
    content: "";
    position: absolute;
    height: 2px;
    width: 100%;
    border-radius: 100px;
    background: -webkit-linear-gradient(110deg, #f794a4 0%, #fdd6bd 100%);
    background: -o-linear-gradient(110deg, #f794a4 0%, #fdd6bd 100%);
    background: linear-gradient(-20deg, #f794a4 0%, #fdd6bd 100%);
    bottom: -4px;
    left: 0;
    -webkit-transition: 0.3s;
    -o-transition: 0.3s;
    transition: 0.3s;
    opacity: 0;
    right: 0;
  }

  .forget-pass a:hover::after {
    opacity: 1;
  }
}
</style>